// Copyright (c) 2016 Deere & Company

import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import Modifier, {getDefaultState as getModifierDefaultState} from './modifier';
import Witness, {getDefaultState as getWitnessDefaultState} from './witness';
import File from './file';
import t from 'tcomb';

const PipCode = t.struct({
    changedBy: Modifier,
    createDate: t.maybe(t.Number),
    createdBy: Modifier,
    customerSummary: CustomerSummary,
    daysRemaining: t.maybe(t.Number),
    dealer: Dealer,
    expireDate: t.maybe(t.Number),
    file: t.list(File),
    internalRecall: t.String,
    pin: t.String,
    pipCodeType: KeyValuePair,
    pipId: t.String,
    pipNumber: t.String,
    pipStatus: KeyValuePair,
    pipType: KeyValuePair,
    postalDeliveryDate: t.maybe(t.Number),
    postalTrackingNumber: t.String,
    processingStatus: t.String,
    reasonForRefusal: t.String,
    refusedDate: t.maybe(t.Number),
    tcsmComments: t.String,
    terminationDate: t.maybe(t.Number),
    territory: t.String,
    transactionId: t.String,
    witness: Witness,
    workOrderNumber: t.String
}, {
    name: 'PipCode',
    strict: true
});

export const getDefaultState = () => new PipCode({
    changedBy: getModifierDefaultState(),
    createDate: null,
    createdBy: getModifierDefaultState(),
    customerSummary: getCustomerSummaryDefaultState(),
    daysRemaining: null,
    dealer: getDealerDefaultState(),
    expireDate: null,
    file: [],
    internalRecall: '',
    pin: '',
    pipCodeType: getKeyValuePairDefaultState(),
    pipId: '',
    pipNumber: '',
    pipStatus: getKeyValuePairDefaultState(),
    pipType: getKeyValuePairDefaultState(),
    postalDeliveryDate: null,
    postalTrackingNumber: '',
    processingStatus: 'NEW',
    reasonForRefusal: '',
    refusedDate: null,
    tcsmComments: '',
    terminationDate: null,
    territory: '',
    transactionId: '',
    witness: getWitnessDefaultState(),
    workOrderNumber: ''
});

export default PipCode;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/pip-code.js